export class StringUtil {
  escapeSpecials(string: string): string {
    const pattern = "\\\\";
    const regexp = new RegExp("[" + pattern + "]", "g");
    return string.replace(regexp, "");
  }

  trimLeft(string: string): string {
    return string.replace(/^\s+/, "");
  }

  trimRight(string: string): string {
    return string.replace(/\s+$/, "");
  }

  trim(string: string): string {
    return string.replace(/^\s+|\s+$/g, "");
  }
}

export class GlobalUtil {
  setLocation(target: string) {
    (window as any).location = target;
  }
}

export class CoreUtil {
  private value = 0;

  nextValue(): number {
    return ++this.value;
  }

  /*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
  counter(start?: number): CoreUtil["nextValue"] {
    return this.nextValue.bind({ value: (start || 1) - 1 });
  }
}

export interface Util {
  string: StringUtil;
  global: GlobalUtil;
  core: CoreUtil;
}

export const util = {
  string: new StringUtil(),
  global: new GlobalUtil(),
  core: new CoreUtil(),
};
